const TaxLookupOptions = [{ value: 'zip-tax', label: 'Zip Tax' }];

export default TaxLookupOptions;
